import t from 'react-translate';
import { css } from '@emotion/react';
import { useSelector } from 'react-redux';
import { primary } from 'styles/global_defaults/colors';
import { getCurrentInstitution } from 'redux/selectors/institutions';
import { PROGRAM_CONFIGURATION_SECTION_WIDTH } from '../../constants';
import ExpertMentoringGuides from './expert-mentoring-guides';
import MenteeLens from './mentee-lens';


const styles = css`
  max-width: ${PROGRAM_CONFIGURATION_SECTION_WIDTH}px;

  a {
    color: ${primary};
  }
`;

const Guidance = () => {
  const { hasAiComponentGeneration } = useSelector(getCurrentInstitution) || {};

  return (
    <div css={styles} className='mx-auto'>
      <div className='title heading-2 mb-2'>
        {t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE.TITLE()}
      </div>
      <div className='text-body black mb-6'>
        {t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE.DESCRIPTION()}
      </div>
      <ExpertMentoringGuides />
      {hasAiComponentGeneration && <MenteeLens />}
    </div>
  );
};

export default Guidance;
